import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import {
  CalendarRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import { pagesConfig } from '../../../shared/pages-config';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';

interface ResourceCalendarsGridToolbarProps {
  calendarRoles: string[];
  selectedCalendars: string[];
  setOpenQuickReports: (open: boolean) => void;
}

export default function ResourceCalendarsGridToolbar({
  calendarRoles,
  selectedCalendars,
  setOpenQuickReports,
}: ResourceCalendarsGridToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          disabled={
            !isAbleToSeeUIElement(
              calendarRoles,
              CalendarRoles.CreateResourceCalendar.value
            )
          }
          onClick={() =>
            navigate(
              `/${pagesConfig.resourceCalendars.link}/${pagesConfig.createResourceCalendar.link}`
            )
          }
          label="Create Resource Calendar"
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="quickReport"
            disabled={selectedCalendars.length === 0}
            onClick={() => setOpenQuickReports(true)}
            tooltipLabel="Quick Reports"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              void queryClient.invalidateQueries({
                queryKey: ['ResourceCalendars'],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="resourceCalendarsGridStates"
            module={ModuleList.modules.calendars.name}
            section={ModuleList.modules.calendars.sections.resourceCalendars}
          />
        </>
      }
    />
  );
}
